// extracted by mini-css-extract-plugin
export default {"sendDescription":"StepFive_sendDescription__d7M8Y","headTitle":"StepFive_headTitle__PA-PX","summary":"StepFive_summary__jAUrY","btns":"StepFive_btns__f6yrM"};